import { Typography } from '@mui/material';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { privacyUrl, termsUrl } from '../utils/constants';
import { useRouter } from 'next/router';

export const TermsAcceptanceText = () => {
  const { locale } = useRouter();
  const { t } = useTranslation(['common', 'auth']);

  return (
    <Typography variant="h6" textAlign="center" color="GrayText">
      {t('auth:terms')}{' '}
      <Link href={privacyUrl(locale)}>{t('common:privacyPolicy')}</Link>{' '}
      {t('common:privacyTermsSeparator')}{' '}
      <Link href={termsUrl(locale)}>{t('common:termsAndConditions')}</Link>.
    </Typography>
  );
};
